<template>
    <el-dialog :title="favInfo.name" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-fav">
    <img src="../assets/images/close.png" alt="关闭" @click="cancelVipHandler()">
    <el-scrollbar wrap-class="vertical_scrollbar">
        <div v-for="(item, index) in fav_list" :key="index" class="fav-item" @click="updateFav(item, index)">
            <div class="stu-name">{{ item.stu_name }}</div>
            <el-button class="school-compare" v-if="item.fav === 0">
                <img src="@/assets/images/fav_icon2.png" alt="设为心仪" class="fav-img1">
                设为心仪
            </el-button>
            <el-button v-else class="school-compare-diff">
                <el-rate
                    v-model="fav_value"
                    disabled
                    :max="1"
                    :show-score="false"
                    score-template="{fav_value}">
                </el-rate>
                {{ favInfo.fav_type === 1 ? '心仪院校': favInfo.fav_type === 2 ? '心仪专业': '心仪职业' }}
            </el-button>
        </div>
    </el-scrollbar>
    </el-dialog>
</template>

<script>
import { addFav, delFav } from '@/api/user'
export default {
    name: 'FavDetail',
    props: ['favList', 'favInfo'],
    data() {
        return {
            fav_value: 1,
            fav_list: []
        };
    },
    mounted() {
        this.fav_list = [...this.favList]
    },
    methods: {
        cancelVipHandler() {
            this.$store.commit("user/SHOWISFAV",false)
        },
        updateFav(item, index) {
            const param = {
                stu_id: item.stu_id,
                fav_type: this.favInfo.fav_type,
                data: this.favInfo.id
            }
            if(item.fav === 0) {
                addFav(param).then(res => {
                    this.fav_list[index].fav = 1
                    this.$forceUpdate()
                    this.$emit('update', this.fav_list)
                    this.cancelVipHandler()
                })
            } else {
                delFav(param).then(res => {
                    this.fav_list[index].fav = 0
                    this.$forceUpdate()
                    this.$emit('update', this.fav_list)
                    this.cancelVipHandler()
                })
            }
        }
    }
}
</script>

<style lang='scss' scoped>
@import "@/assets/css/variables.scss";
.dialog-box {
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    ::v-deep .el-dialog {
        max-height: calc(100% - 300px);
        width: 576px;
        min-height: 368px;
        height: auto!important;
        background: rgba(255,255,255,0.90);
        border-radius: 10px;
        box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.10); 
        backdrop-filter: blur(6px);
        .vertical_scrollbar {
            overflow-x: hidden;
            height: calc(100vh - 620px);
            min-height: 300px;
            padding-bottom: 20px;
        }
        .el-dialog__header {
            text-align: center;
            font-size: 28px;
            line-height: 40px;
        }
        .fav-item {
            background: #ffffff;
            border-radius: 8px;
            padding: 28px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;
        }
        .school-compare,.school-compare-diff {
            width: 118px;
            height: 40px;
            line-height: 40px;
            background: #f0f2f5!important;
            border: none;
            border-radius: 8px;
            color: #5e6166!important;
            font-size: 18px!important;
            padding: 0!important;
            img {
                width: 12px;
                height: 12px;
            }
            .fav-img1 {
                width: 18px;
                height: 18px;
                position: relative;
                top: 2px;
                right: auto;
            }
        }
        .school-compare-diff {
            color: $common-color!important;
            background: #ffeee6!important;
            border: 1px solid #ff6524!important;
            line-height: 38px;
            span {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .stu-name {
            font-size: 20px;
            color: #332e2c;
            line-height: 28px;
        }
        .el-rate__icon {
            color: #ff6524!important;
        }   
    }
}
</style>